import React from "react";
import { Table, TableHead, TableRow, TableCell, TableBody } from "@material-ui/core";

export default function DigitalEnablementTab({ data }) {
// export default function DigitalEnablementTab() {


//       const data = [
//     {
//       trainingDate: "10-02-2026",
//       learning: "Understood basic billing",
//       websiteDate: "15-02-2026",
//       websiteLink: "https://example.com",
//       serviceDate: "18-02-2026",
//       experience: "Good reach",
//       videoDate: "20-02-2026",
//       usage: "Clear understanding",
//       videoLink: "https://video-link.com"
//     },
//     {
//       trainingDate: "12-02-2026",
//       learning: "Learnt invoice features",
//       websiteDate: "17-02-2026",
//       websiteLink: "https://mysite.com",
//       serviceDate: "19-02-2026",
//       experience: "Helpful service",
//       videoDate: "22-02-2026",
//       usage: "Very easy to use",
//       videoLink: "https://brandvideo.com"
//     }
//   ];


  return (
    <div style={{ overflowX: "auto" }}>
      <Table border={1}>
        <TableHead>

          {/* GROUP HEADER */}
          <TableRow style={{ background: "#f3f3f3" }}>
            <TableCell colSpan={2} align="center">
              MeraBills App Training
            </TableCell>

            <TableCell colSpan={2} align="center">
              Website Development
            </TableCell>

            <TableCell colSpan={2} align="center">
              Social Media Service
            </TableCell>

            <TableCell colSpan={3} align="center">
              Brand Video
            </TableCell>
          </TableRow>

          {/* SUB HEADER */}
          <TableRow style={{ background: "#fafafa" }}>
            <TableCell>Training Date</TableCell>
            <TableCell>Learning on Usage</TableCell>

            <TableCell>Website Delivered Date</TableCell>
            <TableCell>Website Link</TableCell>

            <TableCell>Service Delivery Date</TableCell>
            <TableCell>Experience & Effect</TableCell>

            <TableCell>Video Delivered Date</TableCell>
            <TableCell>Usage Clarity & Experience</TableCell>
            <TableCell>Link to Brand Video</TableCell>
          </TableRow>

        </TableHead>

        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>

              <TableCell>{row.trainingDate}</TableCell>
              <TableCell>{row.learning}</TableCell>

              <TableCell>{row.websiteDate}</TableCell>
              <TableCell>{row.websiteLink}</TableCell>

              <TableCell>{row.serviceDate}</TableCell>
              <TableCell>{row.experience}</TableCell>

              <TableCell>{row.videoDate}</TableCell>
              <TableCell>{row.usage}</TableCell>
              <TableCell>{row.videoLink}</TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}